import React, { useState } from 'react'
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
} from "@material-tailwind/react";
import AIcon from '../partials/AIcon'
import { useShared } from '../../hooks/useShared'

export default function ArchiveFilesListModal({ v }) {

    const { com, auth, consts, http, model, setShowFilesModal, showFilesModal } = useShared()
    const [files, setFiles] = useState([...model.attachments])

    console.log(model);

    const closeDialog = () => {
        setShowFilesModal(false)
    }


    const openInNewTab = (obj) => {
        console.log(obj);
        window.open(consts.BASE_URL + obj?.path)
    }

    const removePhoto = async (i, obj) => {

        if (window.confirm("Do you want to delete it?")) {
            const copy = [...files]
            copy.splice(i, 1)
            setFiles(copy)
            if (obj?.id && obj?.id > 0) {
                try {
                    const res = await http.post('api/remove/photo', { attachment: obj })
                    console.log("remove attachment ... ", res);
                    if (res.data.success) {
                        closeDialog()
                        v.refersh()
                    }
                } catch (error) {
                    console.log('error photo remove ', error);
                }
            }
        }
    }

    return (
        <Dialog open={showFilesModal} className={`min-w-[90%] md:min-w-[40%] border-main-color absolute top-0  overflow-y-scroll ${v?.className} ` } size="lg"
            animate={{
                mount: { scale: 1, y: 0 },
                unmount: { scale: 0.9, y: -100 },
            }}

            static
            onClose={() => null}
        >
            <DialogHeader className="bg-main-color py-1 px-2 text-blue-gray-100  text-base flex justify-between">Files
                <Button className="p-0 m-0 bg-transparent" onClick={closeDialog}>  <AIcon name="close-outline" size={20} className="p-1" /> </Button>
            </DialogHeader>
            <DialogBody divider>
                <div>{files?.length > 0 &&
                    <table className='gTable mt-2'>
                        <thead >
                            <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                                <th>#</th>
                                <th>Name</th>
                                <th>Size</th>
                           <th >Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {files?.map((f, i) => {
                                return (
                                    <tr key={f.size + i}>
                                        <td>{i + 1}</td>
                                        <td> <span className=' text-blue-700 cursor-pointer underline' onClick={(e) => openInNewTab(f)}>{f.name}</span> </td>
                                        <td>{com?.formatBytes(f.size)}</td>
                                        <td>
                                            <AIcon onClick={(e) => openInNewTab(f)} name="eye-outline" size={20} className="text-green-700 cursor-pointer hover:text-green-500 mx-1" />
                                         {(model?.status===1||model?.status===0) &&
                                        (auth.hasRole([1,2])|| auth.isCreator(f?.creator_id))&& <AIcon onClick={(e) => removePhoto(i, f)} name="close" size={20} className="text-main-color cursor-pointer hover:text-red-500" />}
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>}
                    </div>
            </DialogBody>

        </Dialog>
    )
}
